export default __webpack_public_path__ + "static/bodySectionBg-1ee815c4a3a07f5fcc714fef89076aea.png";